import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import LanguageIcon from '@mui/icons-material/Language';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';

const mobileMenuId = 'primary-search-account-menu-mobile';
interface IMobileMenuProps {
    handleProfileMenuOpen: ((event: any) => void) | undefined;
    handleLanguageMenuOpen: ((event: any) => void) | undefined;
    handleMenuClose: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void) | undefined;
    AnchorEl: HTMLElement | null;
    isMenuOpen: boolean;
}
function MobileMenu(props: IMobileMenuProps) {
    const { t } = useTranslation('common');
    return (
        <Menu
            anchorEl={props.AnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={props.isMenuOpen}
            onClose={props.handleMenuClose}
        >
            <MenuItem onClick={props.handleLanguageMenuOpen}>
                <IconButton aria-label="Select your preferred language" color="inherit" size="large">
                    <LanguageIcon />
                </IconButton>
                <p>{t("bar.language")}</p>
            </MenuItem>
            <MenuItem onClick={props.handleProfileMenuOpen}>
                <IconButton
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                    size="large">
                    <AccountCircle />
                </IconButton>
                <p>{t("user.profile")}</p>
            </MenuItem>
        </Menu>
    );
}
interface IMobileControlProps {
    handleProfileMenuOpen: ((event: any) => void);
    handleLanguageMenuOpen: ((event: any) => void);

}
export default function MobileMenuControl(props: IMobileControlProps) {

    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleLanguageMenuOpen = (event:any) => {
        handleMobileMenuClose();
        props.handleLanguageMenuOpen(event);
    }
    const handleProfileMenuOpen = (event:any) => {
        handleMobileMenuClose();
        props.handleProfileMenuOpen(event);
    }
    return <>
        <IconButton
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
            size="large">
            <MoreIcon />
        </IconButton>
        <MobileMenu
            handleMenuClose={handleMobileMenuClose}
            AnchorEl={mobileMoreAnchorEl}
            isMenuOpen={isMobileMenuOpen}
            handleLanguageMenuOpen={handleLanguageMenuOpen}
            handleProfileMenuOpen={handleProfileMenuOpen}
        />
    </>;
}